import { createSlice } from '@reduxjs/toolkit'

const contactSlice = createSlice({
    name: 'contact',
    initialState: {
        contactSubmission: false
    },
    reducers: {
        fetchContactAction: (state, action) => {
            state.contactSubmission = action.payload
        }
    }

})

export const {fetchContactAction } = contactSlice.actions

export default contactSlice